<template>
  <!--    修改子集群信息/设置初始化脚本/修改超线程设置      -->
  <div>
    <div class="base-margin__left-20">
      <p>{{ $t('customCluster.activity.adjustingExamplesActivity.operation') }}</p>
      <p class="base-margin__bottom-5 base-margin__left-20">
        {{
          $t('customCluster.activity.adjustingExamplesActivity.adjustInstanceConfig', {
            instanceId: detailsDataInfo.instanceId,
            instanceType: detailsDataInfo.instanceType
          })
        }}
      </p>
      <div v-if="detailsDataInfo.activityStatus !== SubclusterActivityStatusRunning">
        <p>{{ $t('customCluster.activity.adjustingExamplesActivity.result') }}</p>
        <div class="base-margin__left-20">
          <p v-if="detailsDataInfo.errorMessage === ''" class="base-margin__bottom-5">
            {{
              $t('customCluster.activity.adjustingExamplesActivity.success', {action: filterActivity(detailsDataInfo.activityType)})
            }}
          </p>
          <p v-else class="base-margin__bottom-5 base-color__red">
            {{
              $t('customCluster.activity.adjustingExamplesActivity.failed', {action: filterActivity(detailsDataInfo.activityType)})
            }}
          </p>
        </div>
      </div>
    </div>
    <div v-if="detailsDataInfo.errorMessage" class="base-margin__left-20">
      <p class="base-margin__bottom-5 base-color__red base-margin__left-20">
        {{
          $t('customCluster.activity.adjustingExamplesActivity.reason', {
            action: filterActivity(detailsDataInfo.activityType),
            errorMessage: detailsDataInfo.errorMessage
          })
        }}
      </p>
    </div>
  </div>
</template>
<script>
import {SubclusterActivityStatusRunning, SubclusterActivityTypeResetInstanceType} from "@/common/constants";

export default {
  name: 'adjustingExamplesActivity',
  props: {
    detailsData: Object,
  },
  data() {
    return {
      detailsDataInfo: {},
      SubclusterActivityStatusRunning,
    };
  },

  mounted() {
    const instanceId = this.detailsData.detailData[0].instanceId;
    const instanceType = JSON.parse(this.detailsData.event).instanceType;
    this.detailsDataInfo = {...this.detailsData, instanceId, instanceType};
  },

  methods: {
    filterActivity(activityId) {
      switch (activityId) {
        case SubclusterActivityTypeResetInstanceType:
          return this.$t('customCluster.activity.adjustingExamplesActivity.adjustInstanceConfigAction');
        default:
          return '';
      }
    },
  },
};
</script>
